import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { getSupplierCuit } from '../../Store/Ducks/duckSupplier';
import { snackAction } from '../../components/CustomSnakbar';
import { useSnackbar } from 'notistack';

export const AccountStatusForm = ({
    email,
    stateFilter,
    invoiceFilter,
    setStateFilter,
    setInvoiceFilter,
    selectedCuit,
    setSelectedCuit,
    supplierNifError,
    setSupplierNifError,
    statusList
}) => {
    
    const invoiceInputRef = useRef(null);
    const prevEmailRef = useRef(email);
    const dispatch = useDispatch();
    const availablesCUIT = useSelector(store => store.supplier?.data?.availablesCUIT) || [];
    //for testing single nif
    //const availablesCUIT = [useSelector(store => store.supplier?.data?.availablesCUIT?.[0])].filter(Boolean);

    const { enqueueSnackbar } = useSnackbar();

    const state = statusList?.map((status, index) => ({id: index, description: status})) || [];

    useEffect(() => {
        if (prevEmailRef.current !== email) {
            dispatch(getSupplierCuit(email));
            prevEmailRef.current = email;
        }
    }, [email, dispatch])

    useEffect(() => {
      if (availablesCUIT.length === 1){
        setSelectedCuit(availablesCUIT[0].cuit)
      }
    }, [])

    useEffect(() => {
        if (availablesCUIT.length !== 1 && selectedCuit === null) {
            setSupplierNifError(true);
            enqueueSnackbar("Complete el NIF para visualizar los resultados", {
                variant: "warning",
                action: snackAction,
                autoHideDuration: 3000,
            });
        } 
    }, [])

    const handleFilterChange = (e, type) => {
        if (type === 'state') {
            if (e.target.value === 'all') {
                setStateFilter("");
            } else {
                setStateFilter(e.target.value);
            }
        } else if (type === 'invoice') {
            setInvoiceFilter(e.target.value.trim());
            if (e.target.value !== '') {
                invoiceInputRef.current.focus();
            }
        }
    };

    return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography fontSize={18} style={{ width:125, marginLeft:'15px', marginRight: '15px' }}>Estado Cuenta</Typography>
                <FormControl fullWidth sx={{ m: 1, width: 450 }} size="small">
                    {availablesCUIT?.length === 0 ? <TextField
                        id="Supplier_NIF"
                        name="Supplier_NIF"
                        color="success"
                        label="NIF / RFC / CUIT Proveedor"
                        size="small"
                        autoFocus={selectedCuit !== "" ? true : false}
                        value={selectedCuit}
                        style={{fontSize:"15px", marginRight: "10px"}}
                        onChange={e => {
                            setSelectedCuit(e.target.value)
                            setInvoiceFilter("")
                            setStateFilter("")
                            sessionStorage.setItem('selectedCuit', e.target.value);
                            if (e.target.value === '') {
                                setSupplierNifError(true);
                            } else {
                                setSupplierNifError(false);
                            }
                        }
                        }
                        error={supplierNifError}
                    /> : availablesCUIT?.length === 1
                        ? <><InputLabel>
                            NIF / RFC / CUIT Proveedor
                        </InputLabel>
                            <Select
                                variant="outlined"
                                color="success"
                                label="NIF / RFC / CUIT Proveedor"
                                id="Supplier_NIF"
                                name="Supplier_NIF"
                                size="small"
                                value={selectedCuit}
                                onChange={(e) => {
                                    setSelectedCuit(availablesCUIT[0]?.cuit)
                                    sessionStorage.setItem('selectedCuit', availablesCUIT[0]?.cuit);
                                }}
                                style={{ fontSize: "15px", marginRight: "10px" }}
                            >
                                {availablesCUIT.map((cuit) => (
                                    <MenuItem key={cuit.supplierId} value={cuit.cuit} style={{ fontSize: "15px" }}>
                                        {`${cuit.cuit} - ${cuit.supplierDescription}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </>
                        : <><InputLabel>
                            NIF / RFC / CUIT Proveedor
                        </InputLabel><Select
                            variant="outlined"
                            color="success"
                            label="NIF / RFC / CUIT Proveedor"
                            id="Supplier_NIF"
                            name="Supplier_NIF"
                            size="small"
                            value={selectedCuit}
                            onChange={(e) => {
                                setSelectedCuit(e.target.value)
                                sessionStorage.setItem('selectedCuit', e.target.value);
                                if (e.target.value === '') {
                                    setSupplierNifError(true);
                                } else {
                                    setSupplierNifError(false);
                                }
                            }}
                            error={supplierNifError}
                            style={{ fontSize: "15px", marginRight: "10px" }}
                        >
                                {availablesCUIT?.map((cuit) => (
                                    <MenuItem key={cuit.supplierId} value={cuit.cuit} style={{ fontSize: "15px" }}>
                                        {`${cuit.cuit} - ${cuit.supplierDescription}`}
                                    </MenuItem>
                                ))}
                            </Select></>}
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 130 }} size="small">
                    <InputLabel>Filtrar por Estado</InputLabel>
                    <Select
                        value={stateFilter}
                        label="Filtrar por Estado"
                        onChange={(e) => handleFilterChange(e, 'state')}
                        style={{width: '180px'}}
                    >
                        <MenuItem value="all">Todos</MenuItem>
                        {state && state.length > 0 ? state.map(stat => <MenuItem value={stat.description}>{stat.description}</MenuItem>) : null}
                    </Select>
                </FormControl>
                <TextField
                    sx={{ m: 1, minWidth: 130 }}
                    label="Filtrar por #Factura"
                    type="text"
                    value={invoiceFilter}
                    onChange={(e) => handleFilterChange(e, 'invoice')}
                    inputRef={invoiceInputRef}
                    autoFocus={invoiceFilter !== "" ? true : false}
                    size="small"
                    style={{width:'180px'}}
                />
            </div>
    )
}